<div class="reduce-risk-container text-center">
	<div class="reduce-risk-bottom">
		<img
			class="reduce-risk-image"
			src="../../assets/img/paperwork.svg"
			alt=""
		/>
		<h2 class="mb-5 reduce-risk-header">Let Go of Your Paperwork</h2>
		<p class="reduce-risk-content">
			Manual compliance control checkingr practices leave your
			institution at <br class="d-none d-sm-block" />
			risk. Lower costs and proactively address the non-compliances that
			erode <br class="d-none d-sm-block" />
			customer trust by automating compliance processes with our platform.
			Stay up-<br class="d-none d-sm-block" />to-date on your regulatory
			obligations, proactively address cyber security threats,<br
				class="d-none d-sm-block"
			/>
			and safeguard your privacy data.
		</p>
		<a href="https://go.regscale.com/RegScale-Create-Account">
			<button class="free-trial-btn px-5 py-2 mt-5">Find Out How</button>
		</a>
	</div>

	<div
		class="
			container
			government-hero-middle
			d-flex
			flex-column flex-lg-row
			align-items-center
			justify-content-center
		"
	>
		<img
			class="change-left"
			src="../../assets/img/proactive-approach.svg"
			alt=""
		/>

		<div class="change-right">
			<div class="text-gradient">Take a Proactive Approach</div>
			<div class="my-3 my-lg-4 solution-underline"></div>
			<p>
				Shift left your security and compliance by
				<br class="d-none d-md-block" />
				reducing manual efforts. Get a reliable,
				<br class="d-none d-md-block" />
				automated, innovative solution backed by experts
				<br class="d-none d-md-block" />
				you can trust.
			</p>
		</div>
	</div>

	<div class="container">
		<h3 class="regscale-solution-header">
			Banks rank their top three risk management
			<br class="d-none d-md-block" />
			challenges as: 1) Operational risk (including cyber
			<br class="d-none d-md-block" />
			risk and third-party risk), 2) Regulatory
			<br class="d-none d-md-block" />
			compliance, and 3) Credit risk.
		</h3>

		<p>
			Making small changes with RegScale can save millions of
			<br class="d-none d-sm-block" />
			dollars for your organization.
		</p>
	</div>
</div>
